import { Component, OnInit, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { CredentialsMapper } from './../../mappers/credential-mapper';
import { ICredentialEditdataDialogResult } from './../../models/ui/credential-edit-data-dialog-result';
import { EditCredentialViewModel } from './../../models/ui/edit-credential-view-model';

@Component({
  selector: 'howden-credential-edit-dialog',
  templateUrl: './credential-edit-dialog.component.html',
  styleUrls: ['./credential-edit-dialog.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButton,
    MatDialogModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatError,
    MatHint,
    MatIcon
  ]
})
export class CredentialEditDialogComponent implements OnInit {
  dialogref = inject<MatDialogRef<CredentialEditDialogComponent>>(MatDialogRef);
  protected data = inject<ICredentialEditdataDialogResult>(MAT_DIALOG_DATA);

  model: EditCredentialViewModel = new EditCredentialViewModel();

  ngOnInit(): void {
    if (this.data?.value) {
      this.model.loadForm(this.data.value);
    }
  }

  validateUrl(): void {
    const uriVal = this.model.url;
    const res = uriVal.toLocaleLowerCase().startsWith('http://') || uriVal.toLocaleLowerCase().startsWith('https://');
    if (!res) {
      this.model.form.get(this.model.C_URL)?.setErrors({
        'invalidUrl': true
      });
    }
  }

  close(result: boolean): void {
    if (result) {
      if (!this.model.form.valid) {
        return;
      }
      const data = new CredentialsMapper().editViewModelToCredentialDto(this.model);
      this.dialogref.close(data);
    } else {
      this.dialogref.close();
    }
  }

  clean(): void {
    this.model.form.reset();
  }
}
